import React from 'react';
import { Route, Routes } from 'react-router-dom';
import TenantHome from './TenantHome';

export default function TenantRoot() {
	return (
		<div>
			<Routes>
				<Route path="/" element={<TenantHome />} />
			</Routes>
		</div>
	);
}
